<template>
    <div class="page" v-if="isDataLoaded">
        <div class="b1" v-if="!isEmpty(detail.mainImage)">
            <img :src="detail.mainImage" alt="">
        </div>
        <div class="b3">
            <div class="list" data-flex="cross:center">
                <p class="tit f-fs14">品牌：</p>
                <p class="txt1 f-fc8">{{ detail.brand || '--' }}</p>
            </div>
            <div class="list" data-flex="cross:center">
                <p class="tit f-fs14">产品名称：</p>
                <p class="txt1 f-fc8">{{ detail.title || '--' }}</p>
            </div>
            <div class="list" data-flex="cross:center">
                <p class="tit f-fs14">产品型号：</p>
                <p class="txt1">{{ detail.unitType || '--' }}</p>
            </div>
            <div class="list" data-flex="cross:center">
                <p class="tit f-fs14">产品机身号：</p>
                <p class="txt1">{{ detail.deviceNo || '--' }}</p>
            </div>
        </div>
        <div class="b4">
            <div data-flex="cross:center" @click="toUrl(detail.manualUrl)">
                <p data-flex-box="1">查看使用手册</p>
                <img src="../../assets/images/left.png" alt="">
            </div>
        </div>
        <div class="b5">
            <div>服务热线：<span>{{detail.remark}}</span></div>
        </div>

        <div class="b6">
            <div>{{detail.introduce}}</div>
        </div>

        <div class="ops" data-flex="cross:center" v-if="detail.isRepair == 1">
            <div class="s1" hover-class="none" @click="toUrl(detail.repairLink)" data-flex-box="0">一键报修</div>
        </div>
        <!-- <iframe src="https://www.example.com"
                width="100%" height="500" frameborder="0"
                allowfullscreen sandbox>
        <p><a href="https://www.example.com">点击打开嵌入页面</a></p>
        </iframe> -->
        <Evaluate></Evaluate>
    </div>
</template>

<script>
import mix1 from '@/mixins/page'
import { uiShowLoading, uiHideLoading, uiAlert, uiConfirm } from '@/utils/ui'
import { delayAsync } from '@/utils/common'
import { Button, Field, CheckboxGroup, Checkbox } from 'vant'
import MgPopup from '@/components/common/mg-popup'
import Evaluate from '@/components/common/evaluate'
import HeadKf from '@/components/common/head-kf'

export default {
    mixins: [mix1],
    components: {
        [CheckboxGroup.name]: CheckboxGroup,
        [Checkbox.name]: Checkbox,
        [Button.name]: Button,
        [Field.name]: Field,
        Evaluate,
        HeadKf
    },
    data() {
        return {
            id: 0,
            tel: '',
            show: false,
            detail: {}
        }
    },
    methods: {
        // checked(e) {
        //     console.log(e)
        // },
        async getDetail() {
            console.log(this.id)
            const promise = this.apiGet('product.detail', { id: this.id })

            let apiResult = null

            try {
                apiResult = await promise
            } catch (ex) {
                apiResult = null
            }

            if (this.isEmpty(apiResult)) {
                return
            }

            this.detail = apiResult.obj
            this.isDataLoaded = true
        },
        toHome(url) {
            this.$router.push(url)
        },
        bindMobile() { },

        toUrl(url) {
            if (!this.isEmpty(url)) {
                window.location.href = url
            }
        },
    },
    mounted() {

    },
    created() {
        let id = this.$route.query.id
        this.id = id
        this.getDetail()
    }
}
</script>

<style lang="less" scoped>
.page {
    padding-bottom: 150px;
    .b1{
        img {
            width: 100%;
            height: auto;
        }
    }
    .b3 {
        background: #fff;
        margin-top: 10px;

        .tit {
            width: 180px;
            color: #333;
        }

        .txt1 {
            color: #609FFA;
        }

        .list {
            padding: 30px;
            box-sizing: border-box;
            border-bottom: solid 1px #F9F5F5;

            .tit {
                min-width: 200px;
            }
        }
    }

    .b4 {
        padding: 30px;
        box-sizing: border-box;
        background: #fff;
        > div{
            p{
                font-size: 14px;
                color: #D65E5E ;
            }
            img {
                width: 15px;
                height: 24px;
            }
        }
    }
    .b5{
        padding: 30px;
        box-sizing: border-box;
        background: #fff;
        margin-top: 20px;
        color: #B5B5B5;
        font-size: 14px;
        text-align: center;
        span {
            color: #609FFA;
        }
    }
    .b6{
        padding: 30px;
        box-sizing: border-box;
        background: #fff;
        margin-top: 20px;
        color: #B5B5B5;
        font-size: 14px;
    }

    .provideService {
        span {
            text-align: center;
            font-size: 12px;
            color: #fff;
            padding: 4px 8px;
            background: #D65E5E;
            border-radius: 4px;
            margin: 10px;
            display: inline-block;
        }
    }

    .ops {
        background: #fff;
        position: fixed;
        bottom: 0;
        width: 100%;
        padding: 20px 24px;
        box-sizing: border-box;

        span {
            font-size: 16px;
            color: #5bb637;

            &.on {
                color: #e84115;
            }
        }

        .s1 {
            line-height: 70px;
            text-align: center;
            font-size: 14px;
            width: 100%;
            border-radius: 100px;
            background: #205CFF;
            border: solid 1px #205CFF;
            color: #fff;
        }
    }

    .content {
        padding: 30px;
        box-sizing: border-box;

        .tit {
            color: #B5B5B5;
        }

        .checked {
            width: 100%;
            display: inline-block;

            >div {
                float: left;
                width: 33.33%;
                margin: 20px 0px;
            }
        }

        .li {
            p {
                width: 54px;
                height: 54px;
                border: solid 1px #B5B5B5;
                border-radius: 4px;
                text-align: center;
                line-height: 54px;
                color: #B5B5B5;
                margin: 0 6px;
            }

            .on {
                background: #E8C767;
                border: solid 1px #E8C767;
                color: #fff;
            }
        }

        .inp {
            border: solid 1px #B9B9B9;
            width: 100%;
            margin: 0 auto;
            border-radius: 10px;
            margin-bottom: 40px;

            .van-cell {
                padding: 10px;
            }

            .van-cell::after {
                border: none;
            }
        }

        .btn {
            width: 100%;
            text-align: center;
            margin-top: 50px;

            button {
                background: #D65E5E;
                color: #fff;
                border-radius: 100px;
                border-color: #D65E5E;
                width: 225px;
                height: 68px;
                margin: 0 auto;
            }

        }
    }

}
</style>